const getETALabel = deliveryDuration => {
  const eta = parseInt(deliveryDuration, 10);

  if (eta <= 15) {
    return {
      from: '0',
      to: '15',
    };
  }

  if (eta > 15 && eta <= 30) {
    return {
      from: '15',
      to: '30',
    };
  }

  if (eta > 30) {
    return {
      from: '30',
      to: '60',
    };
  }

  return {
    from: 0,
    to: 0,
  };
};

export default getETALabel;



// WEBPACK FOOTER //
// ../utils/functions/get-eta-label.js